import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { addToWishlist, RemoveWishlist } from "../../features/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchWishlists } from "../../features/fetchwishListitem";
import { useNavigate } from "react-router-dom";

const Productdetailsleftcarousel = ({ productsimage, productDetails }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user_id = localStorage.getItem("userId");

  const mainSliderSettings = {
    asNavFor: nav2,
    ref: (slider) => setNav1(slider),
    arrows: false,
    fade: true,
  };

  const thumbnailSliderSettings = {
    asNavFor: nav1,
    ref: (slider) => setNav2(slider),
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  };

  // Fetch wishlist items when the component mounts
  useEffect(() => {
    if (user_id) {
      dispatch(fetchWishlists(user_id));
    }
  }, [dispatch, user_id]);

  const { items: wishlistitems } = useSelector((state) => state.wishlistItems);

  const isInWishlist = (product_id) => {
    return wishlistitems && wishlistitems.some((wishlistItem) => wishlistItem.id === product_id);
  };

  const handleAddtoWishlist = (product_id) => {
    if (!user_id) {
      navigate("/login");
      return;
    }
    dispatch(addToWishlist({ product_id, user_id }));
  };

  const handleRemoveFromWishlist = (product_id) => {
    dispatch(RemoveWishlist({ product_id }));
  };

  // Function to extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    const match = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([\w-]+)/
    );
    return match ? match[1] : null;
  };

  return (
    <div className="product-details-left-carousel">
      <div className="wishlist_box">
        <button
          style={{ cursor: "pointer" }}
          className={isInWishlist(productDetails.id) ? "wishlist_btn_active" : "wishlist_btn_inactive"}
          onClick={() => {
            if (isInWishlist(productDetails.id)) {
              handleRemoveFromWishlist(productDetails.id);
            } else {
              handleAddtoWishlist(productDetails.id);
            }
          }}
        >
          <FontAwesomeIcon icon={faHeart} />
        </button>
      </div>

      {/* Main Slider for Product Images & Video */}
      {(productsimage && productsimage.length > 1) || productDetails.video_link ? (
        <Slider {...mainSliderSettings} className="main_slider">
          {/* Map through product images */}
          {productsimage &&
            productsimage.map((image, index) => (
              <div key={index} className="img_box">
                <img src={image} alt={`Product ${index + 1}`} />
              </div>
            ))}

          {/* Add video link as part of the carousel if videoLink is present */}
          {productDetails.video_link && (
            <div className="video-link-slide">
              <iframe
                width="560"
                height="315"
                src={productDetails.video_link}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </Slider>
      ) : productsimage && productsimage.length === 1 ? (
        <Slider {...mainSliderSettings} className="main_slider">
          <div className="img_box">
            <img src={productsimage[0]} alt="Product" />
          </div>
          {productDetails.video_link && (
            <div className="video-link-slide">
              <iframe
                width="560"
                height="315"
                src={productDetails.video_link}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </Slider>
      ) : null}

      {/* Thumbnail Slider for Product Images & YouTube Video */}
      {productsimage && productsimage.length > 1 ? (
        <Slider {...thumbnailSliderSettings} className="thumbnail-slider">
          {/* Product image thumbnails */}
          {productsimage.map((image, index) => (
            <div key={index} className="img_box">
              <img src={image} alt={`Thumbnail ${index + 1}`} className="thumbnail-image" />
            </div>
          ))}

          {/* YouTube video thumbnail */}
          {productDetails.video_link && (
            <div
              className="img_box"
              onClick={() => {
                if (nav1) nav1.slickGoTo(productsimage.length); // Navigate to the video in the main slider
              }}
            >
              <img
                src={`https://img.youtube.com/vi/${getYouTubeVideoId(productDetails.video_link)}/hqdefault.jpg`}
                alt="YouTube Video Thumbnail"
                className="thumbnail-image"
              />
            </div>
          )}
        </Slider>
      ) : null}
    </div>
  );
};

export default Productdetailsleftcarousel;
